import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ProcedureCodes } from '../../../../../packages/ui/templates/sign-off/components/procedure-codes';
import { sx } from '../SessionSignOffV4.styles';
import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';
import { AddProcedureCodes } from '../../video-call-screen/components/add-procedure-codes';
import { useDomainType } from '../../../../../hooks/useDomainType';
import { getCPTs } from '../../../../../services/state/state.service';
import { stateActionCreators } from '../../../../../redux/modules/state';
import { useDispatch, useSelector } from 'react-redux';
import { reportServiceActionCreators } from '../../../../../redux/modules/report-service';
import { getReportService } from '../../../../../redux/modules/report-service/selectors';
import { DomainTypesEnum } from '../../../../../constants/CommonConstants';
import { colors } from '../../../../../packages';

export const BillingRequirementsSection = ({ appointment, openGiggle }) => {
  const dispatch = useDispatch();

  const { appointmentCptCode } = useSelector(getReportService);

  const [isLoadingDiagnoses, diagnoses, domainElementsList] = useDomainType({
    type: DomainTypesEnum.DIAGNOSES,
    patientId: appointment?.participantId,
  });

  const [openProcedureDrawer, setOpenProcedureDrawer] = useState(false);
  const [cpts, setCpts] = useState([]);
  const [diagnosisList, setDiagnosisList] = useState([]);

  const getProcedureCodeOptionLists = async () => {
    const cptCodesList = await getCPTs();
    setCpts(cptCodesList?.data?.data);
    dispatch(stateActionCreators.fetchICD10());
  };

  useEffect(() => {
    dispatch(reportServiceActionCreators.fetchAppointmentCptCodeById(appointment?.appointmentId));
    getProcedureCodeOptionLists()
      .then()
      .catch(err => {
        console.log('option list fetch failed', err);
      });
  }, []);

  useEffect(() => {
    let tempDiagnosisList = [];
    if (domainElementsList) {
      domainElementsList.forEach(item => {
        if (item.relatedElements?.length) {
          const filteredDiagnises = item.relatedElements?.filter(
            element => element.metaData?.metaDataValues?.icd10Codes,
          );
          tempDiagnosisList = [...filteredDiagnises, ...tempDiagnosisList];
        }
      });
    }
    setDiagnosisList(tempDiagnosisList);
  }, [diagnoses, domainElementsList]);

  const handleAddEditCPTDrawer = () => {
    setOpenProcedureDrawer(true);
  };

  return (
    <Box display="flex" flexDirection="column" gap="40px">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 28,
            lineHeight: '36px',
            color: colors.neutral900,
          }}
        >
          Billing requirements
        </Typography>
        <span className={{ color: colors.neutral600, fontWeight: 500, fontSize: '16px', lineHeight: '24px' }}>
          Kindly revise these codes we selected to maximize compliance.
        </span>
      </Box>
      <ProcedureCodes
        appointment={appointment}
        cpts={cpts}
        appointmentCptCode={appointmentCptCode}
        onClickAdd={handleAddEditCPTDrawer}
      />
      <Drawer
        open={openProcedureDrawer}
        onClose={() => setOpenProcedureDrawer(false)}
        variant={drawerType.NORMAL}
      >
        <AddProcedureCodes
          appointment={appointment}
          appointmentCptCode={appointmentCptCode}
          domainElements={diagnoses?.relatedElements}
          diagnosisList={diagnosisList}
          cpts={cpts}
          onClose={() => setOpenProcedureDrawer(false)}
          isLoadingCPT={isLoadingDiagnoses}
        />
      </Drawer>
    </Box>
  );
};
